// Affichage commande (LOT 7c §5, amendé complément 7c) — module 100 % pur,
// point d'entrée UNIQUE de toutes les cartes : le PRÉNOM prime toujours ;
// sinon « Commande n°X » où X = NUMÉRO DE SERVICE (projection pure, AUCUN
// champ persisté) : rang de création dans le service courant, TOUTES commandes
// comprises (actives, clôturées, annulées) → 1, 2, 3…, aucune renumérotation
// pendant le service, remise à 1 au service suivant.
//
// « Service courant » (réalité du code) : les commandes créées STRICTEMENT
// APRÈS la dernière fin de service — `endServiceT1` clôt la session active
// (`sessions.update({endedAt: now})`) ou en crée une déjà close ; la borne est
// donc max(endedAt) de la table sessions (0 si aucune session).

export interface CommandeAffichable {
  id?: number;
  client_nom_snapshot?: string;
}

// Rang de création (createdAt croissant, puis id) parmi les commandes du
// service courant — statuts confondus : clôturer/annuler ne renumérote pas.
export function numerosDeService(
  commandes: readonly { id?: number; createdAt: number }[],
  finDernierService: number,
): Map<number, number> {
  const duService = commandes
    .filter((c) => c.createdAt > finDernierService)
    .sort((a, b) => a.createdAt - b.createdAt || (a.id ?? 0) - (b.id ?? 0));
  return new Map(duService.map((c, i) => [c.id as number, i + 1]));
}

export function nomAffichage(
  c: CommandeAffichable,
  numeros?: ReadonlyMap<number, number>,
): string {
  if (c.client_nom_snapshot && c.client_nom_snapshot.length > 0) {
    return c.client_nom_snapshot;
  }
  return `Commande n°${numeros?.get(c.id as number) ?? '…'}`;
}
